import React, { PropsWithChildren, useEffect } from 'react';

import Aurora from 'main/components/Animations/Aurora';
import { sendGtagPageView } from 'utils/gtag-event';

import useStyles from './styles';

import { useIsScrolled } from '../../hooks/use-is-scrolled';
import Footer from '../Footer';
import Header from '../Header';

interface Props {
    className?: string;
}

const Layout: React.FC<PropsWithChildren<Props>> = ({ children, className }) => {
    const { classes, cx } = useStyles();

    const [isScrolled, scrollerRef] = useIsScrolled();
    useEffect(() => sendGtagPageView(), []);

    return (
        <div className={cx(classes.root, className)} ref={scrollerRef}>
            <Aurora className={classes.aurora} />
            <div className={classes.content}>
                <Header className={classes.header} blurry={isScrolled} />
                {children}
                <Footer />
            </div>
        </div>
    );
};

export default Layout;
